import { SentMessagesPage } from "@features/communications/components/SentMessagesPage";
import { createFileRoute } from "@tanstack/react-router";
import { requireRouteAudience } from "@services/router/routeAccess";

export const Route = createFileRoute("/_layout/communication/sent")({
	beforeLoad: requireRouteAudience(["staff"]),
	component: SentMessagesPage,
	staticData: { crumb: { label: "My sent messages" } },
});
